import { Breadcrumbs, Typography } from "@material-ui/core";
import { Link, useTranslate } from "react-admin";
import resourceNames from "../../../common/data/resourceNames";
import { SelectedVehicle, VehicleBreadcrumb } from "./VehicleBreadcrumb";

interface BreadcrumbProps {
  vehicle?: SelectedVehicle;
}

export const Breadcrumb = ({ vehicle }: BreadcrumbProps) => {
  const translate = useTranslate();
  return vehicle ? (
    <Breadcrumbs aria-label="breadcrumb" className="vehicle-breadcrumbs">
      <Link to={`/${resourceNames.ASSETS_MAINTENANCE_DASHBOARD}`}>
        <Typography variant="h6">
          {translate("resources.maintenance-dashboard.name")}
        </Typography>
      </Link>
      <VehicleBreadcrumb
        vehicle={vehicle}
        getBasePath={(x) =>
          x
            ? `/${resourceNames.ASSETS_MAINTENANCE_DASHBOARD}/${x.id}`
            : `/${resourceNames.ASSETS_MAINTENANCE_DASHBOARD}`
        }
      />
    </Breadcrumbs>
  ) : (
    <div className="maintenance-dashboard-title">
      <Link to={`/${resourceNames.ASSETS_MAINTENANCE_DASHBOARD}`}>
        <Typography variant="h6">
          {translate("resources.maintenance-dashboard.name")}
        </Typography>
      </Link>
      <VehicleBreadcrumb
        getBasePath={(x) =>
          x
            ? `/${resourceNames.ASSETS_MAINTENANCE_DASHBOARD}/${x.id}`
            : `/${resourceNames.ASSETS_MAINTENANCE_DASHBOARD}`
        }
      />
    </div>
  );
};
